import React from 'react'
import { usePullToRefresh } from '../hooks/usePullToRefresh'

interface Props {
  onRefresh: () => Promise<void> | void
}

export default function PullToRefresh({ onRefresh }: Props) {
  const { pullDistance, refreshing, triggered } = usePullToRefresh(onRefresh)

  const visible = pullDistance > 4 || refreshing

  return (
    <div
      className="pull-indicator"
      style={{
        height: refreshing ? 44 : pullDistance,
        opacity: visible ? 1 : 0,
      }}
    >
      <div
        className={`pull-spinner${refreshing ? ' spinning' : ''}`}
        style={{
          transform: refreshing
            ? undefined
            : `rotate(${(pullDistance / 72) * 360}deg)`,
          opacity: triggered || refreshing ? 1 : 0.5,
        }}
      >
        {refreshing ? '↻' : triggered ? '↑' : '↓'}
      </div>
    </div>
  )
}
